// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HCKN","footer":"styles_footer__1XGtB"};